<style lang="scss" scoped>
  @import "../../../sass/variables";

  .board {
    margin-top: 0px;
  }

  #search-input {
    background-color: transparent;
    outline: 1px solid $salesflow-outline-gray-medium;
    padding: 12px 20px;
    color: $salesflow-font-dark;
    border-radius: 16px;
    font-size: 0.75rem;
    font-weight: 400;
    line-height: 150%;
    min-width: 290px;

    &::placeholder {
      color: $salesflow-font-gray;
    }
  }
  .table-responsive {

    table {
      thead {
        th {
          color: $salesflow-font-gray;
          font-weight: 500;
          font-size: 0.75rem;
          line-height: 125%;
        }
      }

      tbody {
        tr {
          td {
            vertical-align: middle;
            border-top: 1px solid $salesflow-outline-gray-light;

            b {
              font-weight: 600;
            }
          }
        }
      }
    }
  }
</style>

<script>
export default {
  data () {
    return {
      filters: null,
    };
  },

  mounted () {
    this.$http.get('/lead/filter?with_trashed=1')
      .then((response) => {
        this.filters = response.data;
      });
  },
};
</script>
